import { ContextMenuOption } from '../../../../core/components/common/Card/types';

export const ContextMenuOptions: { [key: string]: ContextMenuOption } = {
  EDIT: { label: 'Edit Space' },
  REMOVE_FROM_BOARD: { label: 'Remove from the Board' },
  SET_DEFAULT: { label: 'Set as default' },
  SHARE: { label: 'Share' },
  LEAVE: { label: 'Leave' },
};
